"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import Loading from "@/components/Loading";

/**
 * The access token cookie expired (or was rejected) but a refresh token may
 * still be there - the header keeps showing the visitor as signed in. Renew
 * it and reload the page. The reload is marked either way, so a token the
 * API still rejects can't loop: the page then shows its signed-out landing.
 * Server components can't set cookies, hence this client step.
 */
export default function SessionRefresh() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Loading />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp() {
  let cancelled = false;
  const reload = () => {
    if (cancelled) {
      return;
    }
    const url = new URL(window.location.href);
    url.searchParams.set("refreshed", "1");
    window.location.replace(url.toString());
  };
  fetch("/api/v1/auth/refresh", {
    method: "POST"
  }).then(reload, reload);
  return () => {
    cancelled = true;
  };
}